import { Box, Text } from 'braid-design-system';
import * as styles from './LoadingItem.css';
import type { ComponentProps } from 'react';

export type LoadingBlockVariant = keyof typeof styles.variant;
type LoadingItemWidth = keyof typeof styles.width;
type TextSize = ComponentProps<typeof Text>['size'];
export interface LoadingItemProps {
  size: TextSize;
  width?: LoadingItemWidth;
  lines?: number;
  variant?: LoadingBlockVariant;
}

export const LoadingItem = ({
  size,
  width,
  lines = 1,
  variant = 'standard',
}: LoadingItemProps) => {
  const baseStyles = [styles.block, styles.variant[variant]];

  return (
    <Box component="span" display="block">
      {new Array(lines).fill('').map((_, index) => (
        <Box component="span" display="block" key={`line-${index}`}>
          <Box
            component="span"
            className={[
              baseStyles,
              lines > 1 ? styles.width.full : styles.width[width!],
            ]}
          >
            <Text size={size}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
          </Box>
          {index < lines - 1 ? (
            <Text size={size}>
              <br />
            </Text>
          ) : null}
        </Box>
      ))}
    </Box>
  );
};
